var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutLandingArrowA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 206,
    fill: "none",
    viewBox: "0 0 520 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F71EE",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M513.454 203.466S365-161.53.85 89.496m512.604 113.97c2.507-3.481 5.333-32.583 5.333-32.583m-5.333 32.583c-2.515 3.492-19.355-9.555-23.163-10.006"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLandingArrowA);
export default __webpack_public_path__ + "static/media/aboutLandingArrowA.5bb0ba361776018c3f9d86154fe012ed.svg";
export { ForwardRef as ReactComponent };